import { render, staticRenderFns } from "./compositeHeader.vue?vue&type=template&id=5891b720&scoped=true&"
import script from "./compositeHeader.vue?vue&type=script&lang=js&"
export * from "./compositeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5891b720",
  null
  
)

export default component.exports